import { render, staticRenderFns } from "./DataTableDiscountLocations.vue?vue&type=template&id=74f2058c&scoped=true"
import script from "./DataTableDiscountLocations.vue?vue&type=script&lang=js"
export * from "./DataTableDiscountLocations.vue?vue&type=script&lang=js"
import style0 from "./DataTableDiscountLocations.vue?vue&type=style&index=0&id=74f2058c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f2058c",
  null
  
)

export default component.exports